import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import Spinner from '../../components/ui/Spinner';
import { useMonitoring } from './hooks/useMonitoring';
import UsageCard from './components/UsageCard';

const Monitoring: React.FC = () => {
    const { setCurrentPage } = useAppContext();
    const { usageData, isLoading } = useMonitoring();

    if (isLoading || !usageData) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <Spinner color="blue" size="lg" />
            </div>
        );
    }

    return (
        <div className="space-y-8">
            {/* Cards de uso — limites vindos diretamente da tabela subscription_plans */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <UsageCard
                    title="Usuários"
                    used={usageData.userUsage.used}
                    total={usageData.userUsage.total}
                />
                <UsageCard
                    title="Contatos"
                    used={usageData.contactUsage.used}
                    total={usageData.contactUsage.total}
                />
                <UsageCard
                    title="Conexões de WhatsApp"
                    used={usageData.whatsAppUsage.used}
                    total={usageData.whatsAppUsage.total}
                />
                <UsageCard
                    title="Contas de Anúncio"
                    used={usageData.adAccountUsage.used}
                    total={usageData.adAccountUsage.total}
                />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <Card className="flex flex-col justify-between">
                    <Card.Header className="pb-4">
                        <Card.Title className="text-section-title">Sua assinatura</Card.Title>
                    </Card.Header>
                    <Card.Content className="pt-0 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <p className="text-body text-secondary">
                            Seu plano atual é o <span className="font-bold text-default">{usageData.planName}</span>.
                        </p>
                        <Button onClick={() => setCurrentPage('billing')} size="default">
                            Gerenciar assinatura
                        </Button>
                    </Card.Content>
                </Card>
            </div>
        </div>
    );
};

export default Monitoring;
